import { useNavigate } from "react-router-dom";

export default async function fetchData(url, contexto, params) {
  try {
    const response = await fetch(url + contexto, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorizationToken: localStorage.getItem("id_token"),
      },
      body: JSON.stringify(params),
    });
    if (response.status > 399 && response.status < 500) {
      const result403 = await response.json();
      //console.log("response.........  ", response, "result403", result403);
      result403.error = response.status;
      // console.log("result403", result403);
      return result403;
    }
    const result = await response.json();
    return result.body;
  } catch (error) {
    console.log("error------------------------", error);
    throw error;
  }
}

export async function fetchRecepcion(url, contexto, params) {
  try {
    const response = await fetch(url + contexto, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorizationToken: "As6f1s5Ef65sgf1S3DF1sd",
      },
      body: JSON.stringify(params),
    });
    if (response.status > 399 && response.status < 500) {
      const result403 = await response.json();
      //console.log("response.........  ", response, "result403", result403);
      result403.error = response.status;
      // console.log("result403", result403);
      return result403;
    }
    const result = await response.json();
    return result.body;
  } catch (error) {
    console.log("error------------------------", error);
    throw error;
  }
}

export async function fetchDataLogin(url, contexto, params) {
  try {
    const response = await fetch(url + contexto, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorizationToken: localStorage.getItem("id_token"),
      },
      body: JSON.stringify(params),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
}
